
import {
  Component, Emit, ModelSync, Prop, Vue,
} from 'vue-property-decorator';

@Component
export default class OfferConfirmationDialog extends Vue {
  @Prop({ type: [String, Number], required: true }) principal!: string | number;

  @Prop({ type: [String, Number], required: true }) installmentValue!: string | number;

  @ModelSync('opened', 'opened:change', { type: Boolean })
  readonly isOpened!: boolean;

  @Emit('confirm')
  onOrderConfirm() {
    return null;
  }
}
